import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "app-icon-device-shutdown",
  "use": "app-icon-device-shutdown-usage",
  "viewBox": "0 0 36 36",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 36 36\" id=\"app-icon-device-shutdown\"><g fill=\"#6C92FA\" fill-rule=\"evenodd\"><path d=\"M18 29.485c-6.617 0-12-5.383-12-12 0-4.578 2.554-8.692 6.666-10.735l.668 1.343C9.735 9.882 7.5 13.48 7.5 17.485c0 5.79 4.71 10.5 10.5 10.5s10.5-4.71 10.5-10.5c0-4.005-2.235-7.603-5.834-9.392l.668-1.343C27.445 8.793 30 12.907 30 17.485c0 6.617-5.384 12-12 12\" /><path d=\"M17.25 15.507h1.5V6.242h-1.5z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol